<template>
    <div class="modal fade fixed-end" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="drawer-title">
                        Export
                    </h2>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <ul class="list-group mb-4">
                        <li class="list-group-item list-group-item-action" role="button" @click="downloadCSV">
                            <a>
                                <i class="fas fa-fw fa-file-excel"></i>
                                Estimation Spreadsheet
                            </a>
                        </li>
                        <li class="list-group-item list-group-item-action" role="button" @click="downloadYodizUserstoryCSV">
                            <a>
                                <i class="fas fa-fw fa-file-csv"></i>
                                Yodiz CSV Spreadsheet
                            </a>
                        </li>
                    </ul>

                    <h3>Generate PDF</h3>

                    <div class="mb-3">
                        <label class="control-label">Name</label>
                        <input v-model="fileName" type="text" class="form-control" />
                    </div><!-- /.form-group-material -->

                    <div class="mb-3">
                        <label class="control-label">Highlight Changes Since</label>
                        <multiselect
                            v-model="compareVersion"
                            :options="versionsByDate"
                            :custom-label="versionLabel"
                            :showLabels="false"
                            placeholder="None"
                            track-by="id"
                            name="compare_version">
                        </multiselect>
                    </div>


                    <div class="clearfix"></div>

                    <div class="mb-3">
                        <div class="form-check">
                            <input v-model="withTags" id="checkbox-include-tags" type="checkbox" class="form-check-input" />
                            <label class="form-check-label" for="checkbox-include-tags">Show Costing Groups</label>
                        </div>
                    </div><!-- /.form-group-material -->

                    <div class="mb-3">
                        <label class="control-label">Only Include Costing Groups:</label>
                        <multiselect
                            v-model="groupsSelected"
                            :options="groups"
                            :multiple="true"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :preserve-search="false"
                            :hideSelected="true"
                            placeholder=""
                            :showLabels="false"
                            label="text"
                            track-by="id"
                            name="groups">
                            <!-- <template slot="selection" slot-scope="{ values, search, isOpen }">
                                <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} options selected</span>
                            </template> -->
                        </multiselect>
                    </div><!-- /.form-group -->

                    <div class="row mt-3 mb-4">
                        <div class="col-6">
                            <button @click="downloadDraftPDF" type="button" class="btn btn-sm btn-light">Download Draft</button>
                        </div>
                        <div class="col-6 text-end">
                            <div class="btn-group">
                                <c-button @click="handleCreateMinorVersion" type="button" class="btn btn-sm btn-primary">New Version</c-button>
                                <button type="button" class="btn btn-sm btn-primary dropdown-toggle" v-dropdown aria-haspopup="true" aria-expanded="false">
                                    <span class="visually-hidden">Toggle Dropdown</span>
                                </button>
                                <ul class="dropdown-menu">
                                    <li><a href="#" class="dropdown-item" @click.prevent="handleCreateMajorVersion">Major Version</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <h3 class="mt-4">PDF History</h3>
                    <ul v-if="user_story_document.versions.length > 0" class="list-group">
                        <li v-for="version in user_story_document.versions" :key="version.id" class="list-group-item list-group-item-action" role="button">
                            <a @click="downloadFinalizedPDF(version.id)">
                                <span class="badge bg-primary me-1">{{ version.version }}</span> {{ version.created_at | moment("DD/MM/YYYY") }} at {{ version.created_at | moment("h:mma") }} | {{ version.filename }}
                            </a>
                        </li>
                    </ul>

                    <p v-else>No history.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import { LaddaButton } from 'components/form/input'
    import auth from 'utils/auth'
    import moment from 'moment'
    import { flatMap, filter, first, orderBy } from 'lodash'
    import { CModal } from '@chameleon/chameleon-vue'

    export default {
        extends: CModal,

        components: {
            LaddaButton
        },

        data() {
            return {
                fileName: "",
                withTags: false,
                majorVersion: false,
                selectedGroups: [],
                compareVersionId: null
            }
        },

        computed: {
            ...mapState('groups', ['groups']),
            ...mapState('userStoryDocument', ['user_story_document']),
            ...mapState('epics', ['epics']),
            ...mapState('project', ['project']),

            versionsByDate () {
                return orderBy(this.user_story_document.versions, ['created_at', 'id'], ['desc', 'desc'])
            },

            compareVersion: {
                get () {
                    return this.versionsByDate.find((version) => version.id === this.compareVersionId) || null
                },

                set (value) {
                    this.compareVersionId = value ? value.id : null
                }
            },

            groupsSelected: {
                get () {
                    return this.selectedGroups
                },

                set (value) {
                  this.selectedGroups = value
                }
            },
        },

        created() {
            this.seedDefaults()
        },

        mounted() {
            // CModal resets data when closed, so re-seed the defaults on open
            this.addEventListener('open', () => {
                this.seedDefaults()
            })
        },

        methods: {
            ...mapActions('userStoryDocument', ['createUserStoryDocumentVersion']),

            versionLabel (version) {
                return `${version.version} - ${moment(version.created_at).format('DD/MM/YYYY h:mma')}`
            },

            seedDefaults () {
                this.fileName = `${this.project.title}-${moment().format('YYYY-MM-DD-(hh-mm)')}`
                this.compareVersionId = null
            },

            handleCreateVersion() {
                return this.createUserStoryDocumentVersion({
                    docId: this.user_story_document.id,
                    payload: {
                        tags: this.withTags,
                        majorVersion: this.majorVersion,
                        name: this.fileName,
                        groups: this.selectedGroups.map((item) => item.id),
                        compare_version_id: this.compareVersionId
                    }
                }).then((response) => {

                    //download the new version
                    this.downloadFinalizedPDF(response.data.id)
                })
            },

            handleCreateMinorVersion () {
                this.majorVersion = false
                return this.handleCreateVersion()
            },

            handleCreateMajorVersion () {
                this.majorVersion = true
                return this.handleCreateVersion()
            },

            downloadDraftPDF () {
                var link = `${process.env.VUE_APP_API_URL}/user-story-document/${this.user_story_document.id}/export/draft?token=${auth.getToken()}&tags=${this.withTags ? 1 : 0 }${this.selectedGroups.map((item) => `&groups[]=${item.id}`)}&name=${this.fileName}${this.compareVersionId ? `&compare_version_id=${this.compareVersionId}` : ''}`
                window.open(link)
            },

            downloadFinalizedPDF (id) {
                var link = `${process.env.VUE_APP_API_URL}/user-story-document/${this.user_story_document.id}/versions/${id}/download?token=${auth.getToken()}`
                window.open(link)
            },

            downloadCSV () {
                var link = `${process.env.VUE_APP_API_URL}/user-story-document/${this.user_story_document.id}/draft/csv?token=${auth.getToken()}`
                window.open(link)
            },

            downloadYodizUserstoryCSV () {
                var link = `${process.env.VUE_APP_API_URL}/user-story-document/${this.user_story_document.id}/export/yodiz-csv?token=${auth.getToken()}`
                window.open(link)
            },

            downloadUserStoryDocVersion(version) {
                var link = `${process.env.VUE_APP_API_URL}/user-story-document/${this.user_story_document.id}/export/yodiz-csv?token=${auth.getToken()}`
                window.open(link)
            }
        }
    }
</script>

<style scoped>
span.status {
    display: inline-block;
    letter-spacing: 2px;
    font-weight: 700;
    border-radius: 3px;
    padding: 5px 12px;
    font-size: 13px;
}

span.status.status-danger {
    background: #d9534f;
    color: #fff;
}
</style>
